function E_v_p_v(){

    return(
        <div >
            <h1 style={{ textAlign: "center", color: "black" }}>
                Energetika v priemyselných výrobách
            </h1>
            <hr style={{ color: "#999999", height: "5px"}} />
            
                <p align="left"><a href="./texty/oevpv.htm" target="_blank" rel="noopener noreferrer">Učebná osnova</a></p>
                <p>
                Výhrevnosť plynných palív&nbsp;
                <a title="Vlastnosti plynných palív" target="_blank" rel="noopener noreferrer" href="tabulky/vyhrplyn.htm">tabuľka</a> 
                (<a href='tabulky/vyhrplyn.doc' download='vyhrplyn.doc'>doc</a>)
            </p>
                
            <p style={{ textAlign: "center" }}>&nbsp;</p>
            <strong>Prezentácie a texty:</strong>
            <p>Všetky materiály budú nahraté do systému MOODLE</p>
            <p><strong>Podmienky ukončenia predmetu</strong></p>
            <p>
                <i style={{ color: "#852C39", fontSize: "16px" }}>
                Spôsob hodnotenia a skončenia štúdia predmetu:
                </i>{" "}
                <strong>Klasifikovaný zápočet</strong>
            </p>
            <p>Kontrolovaná účasť na výpočtových cvičeniach a laboratórnych prácach. Ospravedlnená a nahradená neúčasť max.3 hod.</p>
            <p>Vypracovanie a odovzdanie protokolov a zadaní.</p>
            <p>
                Záverečné hodnotenie (ZH): Študent prospeje v ZH a úspešne vykoná skúšku, keď splní podmienku získať <strong>min. 51%</strong> zo 100%.
            </p>
            <p>
                Celkové hodnotenie: CH je suma hodnotení získaných študentom za hodnotené obdobie. Celkový výsledok sa stanoví v súlade s vnútornými predpismi TUKE.
                (študijný poriadok, vnútorný predpis zásady doktorandského štúdia)
            </p>
            <p><strong>LITERATÚRA:</strong></p>
            <ul>
                <li>CIHELKA, J.: Sluneční vytápěcí systémy. SNTL, Praha, 1984, 2. vyd.,</li>
                <li>RYBÁR, R., TAUŠ, P., HORBAJ, P.: Technológie alternatívnych zdrojov. 1. vyd. Košice : TU, 2011.</li>
                <li>MURTINGER, K., BERANOVSKÝ, J., TOMEŠ, M.: .Fotovoltaika, elektřina ze slunce : Elektřina ze slunce, Brno : Era, 2007.</li>
                <li>BRESTOVIČ, T., ČARNOGURSKÁ, M.: Zdroje a premeny energie /. 1. vyd. Košice : TU, 2012.</li>
                <li>DVOŘÁK, L.: Zdroje a přeměny energie, ES ČVUT, Praha, 1990, 1. vyd.</li>
                <li>MARKO, Š.: Energetické zdroje a premeny, Alfa Bratislava, 1989</li>
                <li>ŠTIBRANÝ, P.: Veterná energetika, SAV, Bratislava, 1. vyd., 2000. 254 str., ISBN 80-88780-17-9</li>
                <li>KUDELAS, D., RYBÁR, R., CEHLÁR, M,: Energia vetra. prírodné, technické a ekonomické podmienky jej využitia. 1. vyd. Košice : TU, 2009</li>
                <li>RYBÁR, R., KUDELAS, D.,  BEER, M.:Tradičné zdroje energie : Fosílne palivá, fosílne palivá / 1. vyd. Košice : TU, 2012.</li>
                <li>GARG a PRAKASH,H. P. GARG,: Solar Energy: Fundamentals and Applications, Published by Tata McGraw-Hill Publishing Company Limited, 7 West Patel Nagar, ISBN 0-07-463631-6</li>
                <li>HÄBERLIN H.: Photovoltaics System Design and Practice, WILEY,2012, ISBN: 978-1-119-99285-1</li>
                <li>W. TONG., Wind Power Generation and Wind Turbine Design, Kollmorgen Corporation, USA, WIT Press, 2010</li>
                <li>FRANK ROSILLO-CALLE, PETER de GROOT, SARAH L. HEMSTOCK, JEREMY: Woods,Biomass Assessment Handbook, Energy for a Sustainable Environment, 2015,2nd Revised edition Routledge (Verlag) ISBN 978-1-138-01964-5</li>
                <li>KLENOVČANOVÁ, A., IMRIŠ, I.: Zdroje a premeny energie. MANACON, Prešov, 2006</li>
                <li>JANDAČKA, J., MALCHO, M.: Biomasa ako zdroj energie. GEORG, Žilina, 2007</li>
                <li>MACKAY, DAVID J.C.: Obnoviteľné zdroje energie-s chladnou hlavou. UIT Cambridge Ltd., 2008, preklad SIEA, 2015 [on-line]</li>
            </ul>
            <p>
                O Zemnom plyne: <a href="https://www.spp-distribucia.sk/dodavatelia/informacie/zlozenie-zemneho-plynu-a-emisny-faktor/" target="_blank" rel="noopener noreferrer">Informácie o zložení zemného plynu</a>
            </p>
            <p>
                <a href="https://mais.tuke.sk/index.php" target="_blank" rel="noopener noreferrer" style={{ color: "blue" }}>
                Ďalšie informácie v MAIS-e
                </a>
            </p>
    </div>
    );

};

export default E_v_p_v;